import axios from 'axios'

export default class InicioIMG {
    public async getArchivoIMG(): Promise<string | undefined> {
        const url = process.env.VUE_APP_INICIO
        const response = await axios.get(url)
        // Retorno de datos
        return response.data;
    }
}


